import React from "react";
import OfflineBoltOutlinedIcon from "@mui/icons-material/OfflineBoltOutlined";
import FlareOutlinedIcon from "@mui/icons-material/FlareOutlined";
import AirlineStopsOutlinedIcon from "@mui/icons-material/AirlineStopsOutlined";
import BugReportOutlinedIcon from "@mui/icons-material/BugReportOutlined";
import "./index.scss";
import { HTTP_METHODS, invokeApi } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { TICKET_STATUS } from "../ticket-filters/config";
import { USER_ROLES } from "../../utils/constants";

const cards = [
  {
    label: "Open",
    key: "openTicketCount",
  },
  {
    label: "Decision given Yet to Close",
    key: "resolvedTicketCount",
  },
  {
    label: "Closed",
    key: "closedTicketCount",
  },
  {
    label: "Total tickets",
    key: "totalTicketsCount",
  },
];

const TicketSummaryCards = ({
  title,
  ticketCounts,
  overviewDashboardFilter,
  userDetails,
}) => {
  const status = {
    Open: "OPENED",
    "Decision given Yet to Close": "RESOLVED",
    Closed: "CLOSED",
  };
  const downloadTicketsByStatus = (item) => {
    const ticketStatus = status[item.label];

    const payload = { ...overviewDashboardFilter };
    if (ticketStatus) {
      payload.status = ticketStatus;
    }
    if (ticketStatus === "OPENED") {
      payload.addReopenedTickets = true;
    }
    const url =
      userDetails?.role === USER_ROLES.OEM
        ? `${HOSTNAME}${REST_URLS.OEM_DOWNLOAD_TICKETS}`
        : `${HOSTNAME}${REST_URLS.DOWNLOAD_TICKETS}`;
    invokeApi(
      HTTP_METHODS.GET,
      url,
      null,
      {
        ...payload,
      },
      "blob"
    )
      .then((res) => {
        if (!res.message) {
          const url = window.URL.createObjectURL(res);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Tickets.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((err) => console.error(err));
  };
  return (
    <div className="ticket-summary-cards">
      <div className="title">{title}</div>
      <div className="report-card-list">
        {cards.map((item, index) => {
          return (
            <div className="report-card" key={index}>
              <div className="icon-label">
                <div className="icon-c">{getIcon(index)}</div>

                <div className="title-label">{item.label}</div>
              </div>
              <div
                className="count"
                onClick={() => downloadTicketsByStatus(item)}
              >
                {ticketCounts[item.key] || 0}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

const getIcon = (index) => {
  switch (index) {
    case 0:
      return (
        <OfflineBoltOutlinedIcon
          style={{
            color: "#A03FBF",
          }}
        />
      );
    case 1:
      return (
        <FlareOutlinedIcon
          style={{
            color: "#51459D",
          }}
        />
      );
    case 2:
      return (
        <AirlineStopsOutlinedIcon
          style={{
            color: "#A08BF6",
          }}
        />
      );
    case 3:
      return (
        <BugReportOutlinedIcon
          style={{
            color: "#F98B6B",
          }}
        />
      );
  }
};

export default TicketSummaryCards;
